import React from "react";


import PriorityIcon from "../../../../../../core/gd-components/priority/priority-icon/priority-icon";

export default function FieldPriority_InlineValueNotEmpty(props:any) {

    const valueClasses = Classes("ui5-txt-default ui5-field-dropdown-inline-editable", props.className)

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                <PriorityIcon className="fl-no-shrink m-r-10" priority={props.option.value}/>
                {props.option.label}
            </div>
            {props.children}
        </React.Fragment>
    );
}
